import React from 'react';

interface HeavyRainContentProps {
  feature: {date: string, [key: string]: unknown} | null;
}

const HeavyRainContent: React.FC<HeavyRainContentProps> = ({ feature }) => {
  if (!feature) {
    return (
      <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
        Aucune information disponible
      </div>
    );
  }

  return (
    <>
      {feature.date && (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>Date:</strong> {String(feature.date)}
        </div>
      )}
      
      {feature.precipitation_amount && feature.precipitation_amount !== "" ? (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>Précipitation:</strong> {String(feature.precipitation_amount)}mm
        </div>
      ) : null}
      
      {feature.event_description ? (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>Description:</strong><br/>
          <span style={{ color: '#666', lineHeight: 1.4 }}>{String(feature.event_description)}</span>
        </div>
      ) : null}
      
      {!feature.date && !feature.event_description && !feature.precipitation_amount && (
        <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
          Aucune information disponible
        </div>
      )}
    </>
  );
};

export default HeavyRainContent;
